import React from "react";
import { useTranslation } from "react-i18next";
import { PinInput } from "./PinInput";
import { LinkButton } from "./LinkButton";
import { ForgetEmailLink } from "./SavedAccountLinks";
import { LinkRow, Screen, ScreenBody, ScreenTitle } from "./Screen";

export interface PinLoginProps {
  email: string;
  value: string;
  onChange(value: string): void;
  error?: string;
  disabled?: boolean;
  online: boolean;
  onPassword(): void;
  onForget(): void;
}

export const PinLogin: React.FC<PinLoginProps> = ({
  email,
  value,
  onChange,
  error,
  disabled,
  online,
  onPassword,
  onForget,
}) => {
  const { t } = useTranslation();

  return (
    <Screen testId="login-pin" offline={!online}>
      <ScreenTitle>{t("Enter your PIN")}</ScreenTitle>
      <ScreenBody>{`${t("Signing in as")} ${email}`}</ScreenBody>
      <PinInput
        value={value}
        onChange={onChange}
        error={error}
        disabled={disabled}
      />
      <LinkRow>
        <LinkButton onClick={onPassword} disabled={!online}>
          {t("Log in with password")}
        </LinkButton>
        <ForgetEmailLink email={email} onForget={onForget} />
      </LinkRow>
    </Screen>
  );
};
